// extracted by mini-css-extract-plugin
export var item = "news-list-module--item--713e0";
export var items = "news-list-module--items--89a15";
export var root = "news-list-module--root--9eb35";